export default __webpack_public_path__ + "static/media/lt.384439f6.svg";